<template>
  <div class="content">
    <user-form :datas="dataall"></user-form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.user.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { UserForm } from "@/pages";
export default {
  components: { UserForm },
  data() {
    return {
      dataall: []
    };
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
        // console.log(this.$store.state.saved);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 3) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Фойдаланувчи" });
      },
    Rule(){}
  },
  created: function() {
    let self = this;
    axios
      .get("api/v1/users/id/" + self.$route.params.id)
      .then(function(response) {
        self.dataall = response.data;
        self.dataall.password = "";
        self.dataall.confirm_password = "";
        if (!self.dataall.menu_json) {
          self.dataall.menu_json = {};
        }
        if (!self.dataall.salary_type) {
          self.dataall.salary_type = 'kunlik';
        }
        self.Rule();
      });
  }
};
</script>
